module.exports = __webpack_public_path__ + "img/arrow2.412ec1ab.svg";